export default "__VITE_ASSET__04861d0e__"